import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  const handlePurchaseClick = () => {
    trackInitiateCheckout();
  };
  return <Section id="offer" className="px-6 md:px-12 max-w-4xl mx-auto" data-id="element-86">
      <div className="relative p-8 md:p-16 border border-[#b8860b]/30 bg-[#0a0a0a] text-center overflow-hidden" data-id="element-87">
        {/* Decorative background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-md bg-[#d4a853]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-88" />

        <div className="relative z-10 space-y-8" data-id="element-89">
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-gray-100 leading-tight" data-id="element-90">
            Dejá de ser el motor y <br className="hidden md:block" data-id="element-91" />
            <span className="text-[#f0c674]" data-id="element-92">convertite en el arquitecto.</span>
          </h2>

          <p className="font-sans text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-93">
            Obtené el Blueprint completo, los Workbooks y el sistema de
            Micro-Automatización hoy mismo.
          </p>

          <div className="py-8" data-id="element-94">
            <p className="font-mono text-sm text-gray-500 uppercase tracking-widest mb-2" data-id="element-95">
              Precio Lanzamiento
            </p>
            <div className="flex items-center justify-center space-x-2" data-id="element-96">
              <span className="font-mono text-5xl md:text-7xl font-bold text-[#d4a853]" data-id="element-97">
                $6
              </span>
              <span className="font-mono text-xl text-[#d4a853]/70 mt-4" data-id="element-98">
                USD
              </span>
            </div>
            <p className="font-sans text-sm text-gray-500 mt-2" data-id="element-99">(Pago único)</p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-100">
            <Button fullWidth className="py-5 text-lg" href="https://www.jwmoka.shop/cart/46286948335787:1" onClick={handlePurchaseClick} data-id="element-101">
              Quiero mi Blueprint Ahora
            </Button>
            <p className="font-sans text-sm text-gray-500 mt-6 flex items-center justify-center space-x-2" data-id="element-102">
              <span className="w-2 h-2 rounded-full bg-green-500/50 animate-pulse" data-id="element-103" />
              <span data-id="element-104">Acceso inmediato tras el pago.</span>
            </p>
            <p className="font-serif text-gray-400 italic mt-2" data-id="element-105">
              Tu tiempo no vuelve, las automatizaciones sí.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}